import { RESPONSIVE_RANGES } from 'utils/enums';
import { isFiveVideos, isFourVideos, isThreeVideos } from 'utils/common';

export class DirectionEnum {
  static LEFT = 'LEFT';
  static RIGHT = 'RIGHT';
}

export const updateCarousel = (
  state,
  channelId,
  pageNum,
  perPage,
  videos,
  isLoading,
  position,
  totalNumberOfVideos,
  overrideVideos
) => {
  return [...state].map((carousel) => {
    if (carousel.channelId !== channelId) return carousel;

    return {
      ...carousel,
      channelId: channelId !== null ? channelId : carousel.channelId,
      pageNum: pageNum !== null ? pageNum : carousel.pageNum,
      perPage: perPage !== null ? perPage : carousel.perPage,
      videos: videos !== null ? (overrideVideos ? videos : [...carousel.videos, ...videos]) : carousel.videos,
      position: position !== null ? position : carousel.position,
      totalNumberOfVideos: totalNumberOfVideos !== null ? totalNumberOfVideos : carousel.totalNumberOfVideos,
      isLoading: isLoading !== null ? isLoading : carousel.isLoading,
    };
  });
};

export const startPosition = (viewRange, isRelatedOn) => {
  if (isFiveVideos(viewRange, isRelatedOn)) return 5;
  if (isFourVideos(viewRange, isRelatedOn)) return 4;
  if (isThreeVideos(viewRange, isRelatedOn)) return 3;
  if (viewRange === RESPONSIVE_RANGES.MOBILE_LARGE) return 2;

  return 1;
};

export const getWidthForShifting = (list, direction, numOfVideosToShift) => {
  const width = numOfVideosToShift * list.getElementsByClassName('ct-video-item')[0].getBoundingClientRect().width;
  return direction === DirectionEnum.RIGHT ? -width : width;
};

export const getContainerWidth = () => {
  const container = document.getElementsByClassName('ct-page__content')[0];
  return container ? container.getBoundingClientRect().width : 0;
};
